// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YMSO","textarea":"styles_textarea__1sDlQ"};